
export default function SMSOptInPage() {
  return (
    <div className="min-h-screen bg-white py-12">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-12">
          <h1 className="text-4xl font-bold text-gray-900 mb-4">
            SMS Opt-In Documentation
          </h1>
          <p className="text-xl text-gray-600">
            Fast Funding Capital SMS Consent Process
          </p>
        </div>

        <div className="bg-white border border-gray-200 rounded-xl p-8 mb-8">
          <h2 className="text-2xl font-bold text-gray-900 mb-6">How Users Opt-In to SMS Messages</h2>
          
          <div className="space-y-8">
            <div>
              <h3 className="text-lg font-semibold text-gray-900 mb-4">1. Contact Form Opt-In</h3>
              <div className="bg-gray-50 p-6 rounded-lg">
                <p className="text-sm text-gray-600 mb-4">When users provide their phone number in our contact form:</p>
                <div className="border border-gray-300 rounded-lg p-4 bg-white">
                  <label className="block text-sm font-medium text-gray-700 mb-2">Phone Number</label>
                  <input
                    type="tel"
                    disabled
                    className="w-full px-4 py-3 border border-gray-300 rounded-lg text-sm bg-gray-50"
                    placeholder="(555) 123-4567"
                  />
                  <p className="text-xs text-gray-600 mt-2 mb-2">
                    By providing your phone number, you consent to receive SMS messages from Fast Funding Capital related to services and account updates. Message frequency may vary. Standard message and data rates may apply. Reply STOP to unsubscribe.
                  </p>
                  <label className="flex items-start">
                    <input
                      type="checkbox"
                      disabled
                      className="mt-1 mr-2 h-4 w-4 text-blue-600 border-gray-300 rounded"
                    />
                    <span className="text-xs text-gray-700">
                      I agree to receive SMS messages from Fast Funding Capital *
                    </span>
                  </label>
                </div>
              </div>
            </div>

            <div>
              <h3 className="text-lg font-semibold text-gray-900 mb-4">2. Pre-Approval Form Opt-In</h3>
              <div className="bg-gray-50 p-6 rounded-lg">
                <p className="text-sm text-gray-600 mb-4">When users apply for pre-approval:</p>
                <div className="border border-gray-300 rounded-lg p-4 bg-white">
                  <label className="block text-sm font-medium text-gray-700 mb-2">Phone Number *</label>
                  <input
                    type="tel"
                    disabled
                    className="w-full px-4 py-3 border border-gray-300 rounded-lg text-sm bg-gray-50"
                    placeholder="(555) 123-4567"
                  />
                  <p className="text-xs text-gray-600 mt-2 mb-2">
                    By providing your phone number, you consent to receive SMS messages from Fast Funding Capital related to services and account updates. Message frequency may vary. Standard message and data rates may apply. Reply STOP to unsubscribe.
                  </p>
                  <label className="flex items-start">
                    <input
                      type="checkbox"
                      disabled
                      checked
                      className="mt-1 mr-2 h-4 w-4 text-blue-600 border-gray-300 rounded"
                    />
                    <span className="text-xs text-gray-700">
                      I agree to receive SMS messages from Fast Funding Capital *
                    </span>
                  </label>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="bg-blue-50 border border-blue-200 rounded-xl p-8 mb-8">
          <h2 className="text-2xl font-bold text-gray-900 mb-6">SMS Message Examples</h2>
          
          <div className="space-y-4">
            <div className="bg-white p-4 rounded-lg border border-gray-200">
              <h4 className="font-semibold text-gray-900 mb-2">Appointment Confirmation</h4>
              <p className="text-gray-700 italic">
                "Hi John! This is Jane from Fast Funding Capital. Our appointment for July 20 11:00 AM is confirmed. Please reach out to +1(346) 291-8220 in case you need to reschedule. Reply STOP to unsubscribe."
              </p>
            </div>
            
            <div className="bg-white p-4 rounded-lg border border-gray-200">
              <h4 className="font-semibold text-gray-900 mb-2">Follow-up Message</h4>
              <p className="text-gray-700 italic">
                "Hello, this is Adam from Fast Funding Capital. I am following up with you about our meeting yesterday, would you have time to discuss this today or would you like to reschedule? Reply STOP to cancel."
              </p>
            </div>

            <div className="bg-white p-4 rounded-lg border border-gray-200">
              <h4 className="font-semibold text-gray-900 mb-2">Application Update</h4>
              <p className="text-gray-700 italic">
                "Hi Sarah! Your pre-approval application has been reviewed. Good news - you're approved for up to $500K. Our team will call you within 24 hours to discuss next steps. Reply STOP to unsubscribe."
              </p>
            </div>
          </div>
        </div>

        <div className="bg-green-50 border border-green-200 rounded-xl p-8">
          <h2 className="text-2xl font-bold text-gray-900 mb-6">Compliance Information</h2>
          
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
            <div>
              <h3 className="text-lg font-semibold text-gray-900 mb-3">Opt-In Requirements</h3>
              <ul className="text-gray-700 space-y-2">
                <li className="flex items-start">
                  <div className="w-5 h-5 flex items-center justify-center mr-2 mt-0.5">
                    <i className="ri-check-circle-line text-green-600"></i>
                  </div>
                  Express consent required
                </li>
                <li className="flex items-start">
                  <div className="w-5 h-5 flex items-center justify-center mr-2 mt-0.5">
                    <i className="ri-check-circle-line text-green-600"></i>
                  </div>
                  Clear checkbox confirmation
                </li>
                <li className="flex items-start">
                  <div className="w-5 h-5 flex items-center justify-center mr-2 mt-0.5">
                    <i className="ri-check-circle-line text-green-600"></i>
                  </div>
                  Opt-out instructions provided
                </li>
                <li className="flex items-start">
                  <div className="w-5 h-5 flex items-center justify-center mr-2 mt-0.5">
                    <i className="ri-check-circle-line text-green-600"></i>
                  </div>
                  Message frequency disclosed
                </li>
              </ul>
            </div>
            
            <div>
              <h3 className="text-lg font-semibold text-gray-900 mb-3">Contact Information</h3>
              <div className="text-gray-700 space-y-2">
                <p><strong>Company:</strong> Fast Funding Capital</p>
                <p><strong>Phone:</strong> 346.291.8220</p>
                <p><strong>Email:</strong> info@fastfundingcap.com</p>
                <p><strong>Address:</strong> 5161 San Felipe, Houston, TX 77056</p>
              </div>
            </div>
          </div>
        </div>

        <div className="text-center mt-8 text-sm text-gray-500">
          <p>This documentation demonstrates Fast Funding Capital's SMS opt-in compliance process.</p>
          <p>Last updated: {new Date().toLocaleDateString()}</p>
        </div>
      </div>
    </div>
  );
}
